import React from 'react';
import { BarChart2Icon } from 'lucide-react';
interface PorkPrimalRow {
  name: string;
  value: string;
}
const porkPrimalData: PorkPrimalRow[] = [{
  name: 'Carcass',
  value: '$0.99'
}, {
  name: 'Loin',
  value: '$0.93'
}, {
  name: 'Butt',
  value: '$1.14'
}, {
  name: 'Picnic',
  value: '$0.74'
}, {
  name: 'Rib',
  value: '$1.67'
}, {
  name: 'Ham',
  value: '$0.85'
}, {
  name: 'Belly',
  value: '$1.49'
}];
export function PorkPrimalsTable() {
  return <div className="mb-12" data-id="element-289">
      <div className="mb-4" data-id="element-290">
        <div className="flex items-center gap-2 mb-1" data-id="element-291">
          <BarChart2Icon className="w-5 h-5 text-gray-700" data-id="element-292" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-293">
            Pork Primal Values
          </h3>
        </div>
        <p className="text-sm text-gray-500" data-id="element-294">2026-04-13 – $/lb</p>
      </div>

      <div className="overflow-x-auto" data-id="element-295">
        <table className="w-full text-sm" data-id="element-296">
          <thead data-id="element-297">
            <tr className="border-b border-gray-200" data-id="element-298">
              <th className="text-left py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-299">
                Item
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-300">
                Value
              </th>
            </tr>
          </thead>
          <tbody data-id="element-301">
            {porkPrimalData.map((row, idx) => <tr key={idx} className={`border-b border-gray-100 ${idx === 0 ? 'bg-gray-50 font-semibold' : ''}`} data-id="element-302">
                <td className="py-4 px-4 text-gray-900 font-medium" data-id="element-303">
                  {row.name}
                </td>
                <td className="py-4 px-4 text-right font-semibold text-gray-900" data-id="element-304">
                  {row.value}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Deep Dive Link */}
      <div className="mt-4 flex justify-end" data-id="element-305">
        <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-[#002f5f] hover:underline flex items-center gap-1" data-id="element-306">
          View Detailed Analysis
          <BarChart2Icon className="w-3 h-3" data-id="element-307" />
        </a>
      </div>
    </div>;
}